import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ElementRef, inject, Injectable, Type } from '@angular/core';
import { ComponentPortal } from '@angular/cdk/portal';
import { FlyoutShellComponent } from '../components/flyout-shell/flyout-shell.component';

@Injectable({
  providedIn: 'root',
})
export class FlyoutService {
  private overlay = inject(Overlay);
  private anchorElement?: ElementRef;

  setAnchor(anchor: ElementRef) {
    this.anchorElement = anchor;
  }

  open<T>(component: Type<T>) {
    if (!this.anchorElement) {
      throw new Error('Flyout Service: [appFlyoutAnchor] directive not found!');
    }

    const config = new OverlayConfig({
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(this.anchorElement)
        .withPositions([
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'top',
          },
        ]),
      width: '350px',
      height: '100%',
      hasBackdrop: true,
      backdropClass: 'flyout-backdrop-custom',
    });

    const overlayRef = this.overlay.create(config);
    const shellRef = overlayRef.attach(
      new ComponentPortal(FlyoutShellComponent),
    );
    shellRef.instance.overlayRef = overlayRef;
    shellRef.instance.contentComponent.set(component);

    overlayRef.backdropClick().subscribe(() => shellRef.instance.close());

    return overlayRef;
  }
}
